<!-- =========================================================================================
  File Name: ExhibitorList.vue
  Description: Exhibitor List Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style scoped>
button.vs-component.vs-button.ml-3.setting-btn.vs-button-primary.vs-button-border {
  padding: 6px !important;
}
.setting-btn span img {
  height: 20px;
  width: 20px;
}
.file-up-section {
  text-align: center;
  border: 2px dashed #c8c8c8;
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
}
.file-up-section p {
  color: #4c8af6;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px;
}
.header-custome {
  margin-bottom: 15px;
  padding-left: 2px;
}
.header-custome {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.knowlg-base-wrap-sec a {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 12px;
}
.knowlg-base-wrap-sec a span {
  margin-right: 10px;
  line-height: 0;
}

.menu-dragbox .vs-list--item {
  background: #ddd;
  margin-bottom: 10px;
  border-radius: 5px;
}

.menu-dragbox {
  height: 340px;
  overflow-y: scroll;
}

.vs-list--item {
  position: relative;
}
/*.vs-input-primary {
  position: absolute;
  left: 4px;
  top: 0;
}*/
.menu-editwrap span:first-child {
  display: inline-flex;
  height: 100%;
  background: transparent;
  margin-left: 10px;
  color: #cc8899;
  padding: 4px 14px;
  margin-top: 0;
  border-radius: 3px;
}
.menu-editwrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
    
    	<vs-tabs v-model="activeTab">
		  <vs-tab label="Booth"  v-on:click="$router.push(`/event/boothmaps/${$route.params.mid}`)">
		    <div class="tab-text">
		      <span>Booth</span>
		    </div>
		  </vs-tab>  

		  <vs-tab label="Route">
		    <vs-table :data="pageData">
		        <template slot="thead">
		          <vs-th>Name</vs-th>
		          <vs-th>Publish</vs-th>
		          <vs-th>Action</vs-th>
		        </template>

		        <template slot-scope="{ data }">
		          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
		            <vs-td :data="data[indextr].Name">{{
		              data[indextr].Name
		            }}</vs-td>
		            <vs-td>
		            	<vs-switch v-model="data[indextr].IsPublished" @input="changeStatus(data[indextr].IsPublished, data[indextr].ID)">
						      </vs-switch>
		            </vs-td>
		            <vs-td :data="data[indextr].ID">		              
		              <feather-icon
		                icon="EyeIcon"
		                title="View"
		                svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
		                @click="getRootMapDetail(data[indextr].ID)"
		              />
		            </vs-td>
		          </vs-tr>
		        </template>
		    </vs-table>
		  </vs-tab>

		</vs-tabs>

		<div class="flex justify-center items-center mt-2">
          <vs-button class="ml-0" @click="openSelectBoothsPopup">Draw Path</vs-button>          
          <vs-button class="ml-3" @click="reset_rootmapData">Clear Path</vs-button>
        </div>

    </div>
    <div class="vx-card p-6 mt-3" v-show="TotalWidth && TotalHeight">
    	<div class="flex justify-center items-center mt-2 mb-2">	 
	    	<div class="vx-col md:w-1/3 w-full ">
			    <label>Start</label>
			    <span>{{startPosition}}</span> 
			</div>
	    	<div class="vx-col md:w-1/3 w-full ml-0">
			    <label>Name <span class="text-danger text-sm">*</span></label>
			    <vs-input class="inputx w-full" name="Name" v-model="RootName" v-validate="'required'" />    
			    <span class="text-danger text-sm" v-show="errors.has('Name')">{{errors.first("Name")}}</span>    
			</div>
			<div class="vx-col md:w-1/3 w-full mt-5 ml-3" v-if="!viewOnly">
			    <vs-button @click="before_save">Save Path</vs-button>       
			</div>
			<div class="vx-col md:w-1/3 w-full ml-5">
				<label>End</label>
				<span>{{lineCoordinates}}</span>
			</div>
		</div>
	    <div :style="'border:1px solid; background-image: url('+mapImgSrc+'); width:'+TotalWidth+'px; height:'+TotalHeight+'px;'">
				<canvas id="boxContainer" style="position:absolute" ></canvas>
				<canvas id="drawContainer" :width="TotalWidth" :height="TotalHeight" style="position:absolute" ></canvas>
			</div>
    </div>

    <vs-popup
        class="holamundo"
        title="Select Booths"
        :active.sync="popupSelectBooths"
    >
    	<div class="row">
    		<div class="vx-col md:w-1/3 w-full mt-2">
		        <label>Source</label>
		        <v-select		          
		          v-model="SourceBooth"
		          label="Name"
		          :options="BoothMapList"
		          :dir="$vs.rtl ? 'rtl' : 'ltr'"
		        />
		    </div>
		    <div class="vx-col md:w-1/3 w-full mt-2">
		        <label>Destination</label>
		        <v-select		          
		          v-model="DestinationBooth"
		          label="Name"
		          :options="BoothMapList"
		          :dir="$vs.rtl ? 'rtl' : 'ltr'"
		        />
		    </div>
    	</div>
        <div class="flex justify-center items-center mt-2">
          <vs-button class="ml-0" @click="setBoothsPositions">Proceed</vs-button>
        </div>
    </vs-popup>
    
  </div>
</template>
<script>
// Store Module
import moduleFloorMapManagement from "@/store/floormap-management/moduleFloorMapManagement.js";
import vSelect from "vue-select";
// Cell Renderer

//console.log(db);

export default {
  components: {
    // Cell Renderer
    vSelect
  },
  data() {
    return {    
      activeTab: 1,
      searchQuery: "",  
      gridOptions: {},
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },      
      TotalWidth: 0,
      TotalHeight: 0,
      mapImgSrc: null,    
      canvasEle: null,
	  context: null,
	  startPosition: {x: 0, y: 0},
	  lineCoordinates: {x: 0, y: 0},
	  isDrawStart: false,  

	  popupSelectBooths: false,
	  BoothMapList: [],
	  SourceBooth: null,
	  DestinationBooth: null,
	  RootName: null,
	  viewOnly: false

    };
  },
  watch: {
    
  },
  computed: {
    pageData() {
      return this.$store.state.floorMapManagement.rootmaps.filter(item=>	item.ParentID == this.$route.params.mid);
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 5;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
  	setCanvasBoxes(){
  		if(this.TotalWidth && this.TotalHeight && this.SourceBooth && this.DestinationBooth){
			let canvasBoxes = document.getElementById('boxContainer');
			let ctx = canvasBoxes.getContext('2d');	
			canvasBoxes.width = this.TotalWidth;
			canvasBoxes.height = this.TotalHeight;
			ctx.fillStyle  = 'rgba(0,0,255,0.5)';	
			ctx.fillRect(this.SourceBooth.Left, this.SourceBooth.Top, this.SourceBooth.Width, this.SourceBooth.Hight);			
			ctx.fillRect(this.DestinationBooth.Left, this.DestinationBooth.Top, this.DestinationBooth.Width, this.DestinationBooth.Hight);			
			ctx.fillStyle  = 'white';
			ctx.font = "20px Arial";
			ctx.fillText("A",this.SourceBooth.Left+5, this.SourceBooth.Top+20);
			ctx.fillText("B",this.DestinationBooth.Left+5, this.DestinationBooth.Top+20);		
		}
	},
	setCanvasRootPath(){
		if(this.startPosition && this.lineCoordinates){
			let canvasBoxes = document.getElementById('boxContainer');
			let ctx = canvasBoxes.getContext('2d');
			ctx.beginPath();	
			ctx.lineWidth = '5';
		  ctx.strokeStyle = 'yellow';
			ctx.moveTo(this.startPosition.X, this.startPosition.Y);
			ctx.lineTo(this.lineCoordinates.X, this.lineCoordinates.Y);
			ctx.stroke();
		}
	},
	initCanvas(){
		this.canvasEle = document.getElementById('drawContainer');
		this.context = this.canvasEle.getContext('2d');	

		this.canvasEle.addEventListener('mousedown', this.mouseDownListener);
		this.canvasEle.addEventListener('mousemove', this.mouseMoveListener);
		this.canvasEle.addEventListener('mouseup', this.mouseupListener);

		this.canvasEle.addEventListener('touchstart', this.mouseDownListener);
		this.canvasEle.addEventListener('touchmove', this.mouseMoveListener);
		this.canvasEle.addEventListener('touchend', this.mouseupListener);
	},
	getClientOffset (event) {
	    //const {pageX, pageY} = event.touches ? event.touches[0] : event;
	    let mousePos = event.target.getBoundingClientRect();
	    const x = event.clientX - mousePos.left ;
	    const y = event.clientY  - mousePos.top;
	    //const x = pageX - this.canvasEle.offsetLeft;
		//const y = pageY - this.canvasEle.offsetTop;
	    return {
	       x,
	       y
	    } 
	},
	drawLine () {
	   let startPosition = this.startPosition;
	   let lineCoordinates = this.lineCoordinates;		   
	   this.context.beginPath();
	   this.context.lineWidth = '5';
	   this.context.strokeStyle = 'red';
	   this.context.moveTo(startPosition.x, startPosition.y);
	   this.context.lineTo(lineCoordinates.x, lineCoordinates.y);
	   this.context.stroke();
	},
	mouseDownListener (event) {	
		this.clearCanvas();			
	   this.startPosition = this.getClientOffset(event);
	   this.isDrawStart = true;
	},
	mouseMoveListener (event) {
	  if(!this.isDrawStart) return;		  
	  this.lineCoordinates = this.getClientOffset(event);
	  this.clearCanvas();
	  this.drawLine();
	},
	mouseupListener (event) {
	  this.isDrawStart = false;
	},
	clearCanvas() {
		if(this.canvasEle)
	   this.context.clearRect(0, 0, this.canvasEle.width, this.canvasEle.height);	   
	},
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    setBoothsPositions(){
    	if(this.SourceBooth && this.DestinationBooth){
	    	if(this.SourceBooth.ID == this.DestinationBooth.ID){ 
	    		this.$vs.notify({
	            color: "warning",
	            position: "top-center",
	            text: "Source & Destination should be different!",
	          });
	    		return false;
	    	}	    		    	
	    	this.popupSelectBooths = false;
	    	this.setCanvasBoxes();
	    	this.initCanvas();
	    	this.viewOnly = false;
	    }
    },
    openSelectBoothsPopup(){
    	this.$vs.loading();
    	this.$store.dispatch("floorMapManagement/fetchBoothMaps").then(res=>{
    		this.$vs.loading.close();
    		this.BoothMapList = res.filter(item=> item.IsPublished &&	item.ParentID == this.$route.params.mid);
    		this.popupSelectBooths = true;
    	})
    },
    getFloorMapDetail(mapId){
      this.$store.dispatch("floorMapManagement/fetchFloorMap", mapId).then(res=>{
        if(res.status == 200){
          this.mapImgSrc = res.data.MapImage;
          this.TotalWidth = res.data.TotalWidth;
          this.TotalHeight = res.data.TotalHeight;    	        
        }
      })
    },    
    getRootMapDetail(rmapId){
    	this.$vs.loading();
      this.$store.dispatch("floorMapManagement/fetchRootMap", rmapId).then(res=>{
      	this.$vs.loading.close();
      	this.reset_rootmapData();
        if(res.status == 200){
          this.SourceBooth = res.data.SourceBooth;
					this.DestinationBooth = res.data.DestinationBooth;
					this.RootName = res.data.Name;
					this.startPosition = res.data.Coordinates[0];
		  		this.lineCoordinates = res.data.Coordinates[1];
		  		this.setBoothsPositions();
		  		this.setCanvasRootPath();
		  		this.viewOnly = true;
        }else{
        	this.$vs.notify({
	            color: "warning",
	            position: "top-center",
	            //title: "Page",
	            text: "Unable to fetch data!",
	          });
        	this.reset_boothmapData();
        }
      })
    },
    before_save() {
		  this.$validator.validateAll().then((result) => {
		    if (result) {
		      // if form have no errors
		      this.save_changes();
		    }
		  });
		},
		save_changes() {
			if(!this.SourceBooth || !this.DestinationBooth) return false;
		  this.$vs.loading();
		  let Coordinates = [
		  	{
		  		Name: "",
		  		X: this.startPosition.x,
		  		Y: this.startPosition.y
		  	},
		  	{
		  		Name: "",
		  		X: this.lineCoordinates.x,
		  		Y: this.lineCoordinates.y
		  	}
		  ];

		  let rootData = {
		  	SourceBooth: this.SourceBooth,
				DestinationBooth: this.DestinationBooth,
		  	BoothIDEnd: this.DestinationBooth.ID,
		  	BoothIDStart: this.SourceBooth.ID,
		  	Coordinates: Coordinates,
		  	ID: null,
		  	Name: this.RootName,
		  	ParentID: this.$route.params.mid
		  }
	      this.$store
	        .dispatch("floorMapManagement/addRootMap", { data: rootData })
	        .then((res) => {
	        	if (res.status == 200) {
		          this.$vs.notify({
		            color: "success",
		            position: "top-center",
		            //title: "Page",
		            text: "Data added successfully.",
		          });
		          this.$vs.loading.close();
	          
	            this.reset_rootmapData();
	            this.$store.dispatch("floorMapManagement/fetchRootMaps");
	          }
	        })
		},
		reset_rootmapData(){
			let canvasBoxes = document.getElementById('boxContainer');
			let ctx = canvasBoxes.getContext('2d');	
			ctx.clearRect(0, 0, this.TotalWidth, this.TotalHeight);
		  this.SourceBooth = null;
		  this.DestinationBooth = null;
		  this.RootName = null;
		  this.clearCanvas();
		  this.startPosition = {x: 0, y: 0};
		  this.lineCoordinates = {x: 0, y: 0};
		},
		changeStatus(value, ID){
      this.$vs.loading();
      this.$store.dispatch("floorMapManagement/changeStatusRootmap", {'IsPublished':value,'id':ID}).then(res=>{
        this.$vs.loading.close();
      })
    },
  },

  mounted() {
    this.gridApi = this.gridOptions.api;
    //this.gridApi.setDomLayout('normal');
    //this.gridApi.setRowData(ta(this.gridApi.paginationGetTotalPages()));
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }    

  },
  created() {
    if(!this.$route.params.mid) 
      this.$router.push(`/event/floormaps`);
    if (!moduleFloorMapManagement.isRegistered) {
      this.$store.registerModule("floorMapManagement", moduleFloorMapManagement);
      moduleFloorMapManagement.isRegistered = true;
    }
    this.$store.dispatch("floorMapManagement/fetchRootMaps");
    this.getFloorMapDetail(this.$route.params.mid);
    
  },
};
</script>